var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-options" }, [
    _c(
      "button",
      {
        staticClass:
          "login-option-button button-blurred option-akkodis border-animation",
        on: {
          click: function($event) {
            return _vm.loginUserWithSSO(_vm.ssoLoginType.akka)
          }
        }
      },
      [
        _c("img", {
          staticClass: "login-button-icon",
          attrs: {
            src: require("@/common/assets/images/akkodis-option.webp"),
            alt: "akka"
          }
        }),
        _vm._v(" Sign in with Akkodis account ")
      ]
    ),
    _c(
      "button",
      {
        staticClass:
          "login-option-button button-blurred option-adecco border-animation",
        on: {
          click: function($event) {
            return _vm.loginUserWithSSO(_vm.ssoLoginType.adecco)
          }
        }
      },
      [
        _c("img", {
          staticClass: "login-button-icon adecco-option",
          attrs: {
            src: require("@/common/assets/images/adecco-option.svg"),
            alt: "adecco"
          }
        }),
        _vm._v(" Sign in with Adecco Group account ")
      ]
    ),
    _c(
      "button",
      {
        staticClass: "login-option-button button-blurred option-guest",
        on: {
          click: function($event) {
            return _vm.redirectTo("sign-in")
          }
        }
      },
      [
        _c("img", {
          staticClass: "login-button-icon guest-option not-filled",
          attrs: {
            src: require("@/common/assets/images/guest-option.svg"),
            alt: "guest"
          }
        }),
        _vm._v(" Sign in as a Guest ")
      ]
    ),
    _vm._m(0),
    _c(
      "button",
      {
        staticClass: "login-option-button request-guest border-animation",
        on: {
          click: function($event) {
            return _vm.redirectTo("register")
          }
        }
      },
      [_vm._v(" Request a Guest Account ")]
    ),
    _c("span", { staticClass: "login-informative" }, [
      _vm._v(
        "Once approved by the DRC team, you will be granted a Guest account."
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "divider" }, [
      _c("span", { staticClass: "login-informative informative-attribute" }, [
        _vm._v("or if you don’t have an account")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }